import TransactionResource from "./transaction.resource";

const transactionModule = angular
  .module("app.resources.transaction", [])
  .service("Transaction", TransactionResource);

export default transactionModule;



// WEBPACK FOOTER //
// ./src/resources/transaction/transaction.module.js